import { faqItems } from '@/mocks/homeData';

export default function Faq() {
  return (
    <section id="faq" className="py-16 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-900">
            常见问题
          </h2>
          <div className="mt-4 w-16 h-1 bg-primary-500 mx-auto rounded-full"></div>
          <p className="mt-3 text-sm text-foreground-600">关于51吃瓜网站的常见疑问解答</p>
        </div>

        <div className="max-w-[800px] mx-auto space-y-4 md:space-y-5">
          {faqItems.map((item, i) => (
            <div
              key={i}
              className="rounded-xl bg-background-100 border border-background-200/70 overflow-hidden"
            >
              <div className="p-5 md:p-6">
                <h3 className="text-base md:text-lg font-semibold text-foreground-900 font-heading flex items-start gap-3">
                  <span className="flex-shrink-0 w-6 h-6 rounded-full bg-primary-100 flex items-center justify-center mt-0.5">
                    <span className="text-xs font-bold text-primary-600">Q</span>
                  </span>
                  {item.question}
                </h3>
                <div className="mt-4 pl-9">
                  <p className="text-sm md:text-base text-foreground-700 leading-relaxed">
                    {item.answer}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}